import { render, staticRenderFns } from "./ChatRoomDropdown.vue?vue&type=template&id=ed6e1c68&scoped=true"
import script from "./ChatRoomDropdown.vue?vue&type=script&lang=js"
export * from "./ChatRoomDropdown.vue?vue&type=script&lang=js"
import style0 from "./ChatRoomDropdown.vue?vue&type=style&index=0&id=ed6e1c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6e1c68",
  null
  
)

export default component.exports